var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"option-end"},[_c('h4',[_c('i',{staticClass:"el-icon-minus"}),_vm._v(" オプション 終了 ")])])}]

export { render, staticRenderFns }